












import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
import { AppGetterTypes } from "../store";
import { IPromotionModel } from "../models";

@Component
export default class CartImage extends Vue {
    @Getter(AppGetterTypes.promotion)
    promotion!: IPromotionModel;

    get imgAltText(): string {
        if (!this.promotion || !this.promotion.products) {
            return "Product Image";
        }

        let productsNameString;
        for (const product of this.promotion.products) {
            if (!productsNameString) {
                productsNameString = product.name;
            } else {
                productsNameString += " and " + product.name;
            }
        }
        const productName =
            this.promotion.products.length > 1
                ? productsNameString
                : this.promotion.products[0].name;

        return productName + " Product Image";
    }
}
